import type React from 'react';

import { CircleX } from 'lucide-react';

import { closeModal } from '@/components/modals/modals.utils';
import { ModalBase } from '@/components/modals/modals-base';
import { ImageCarousel } from '@/components/ui/image-carousel';
import useClickOutside from '@/hooks/use-click-outside';

type ViewMediaImage = {
  creatorId?: string | null;
  deletedAt?: string | null;
  estateId?: string | null;
  fileName: string | null;
  name: string | null;
  id: string;
  createdAt?: string | null;
  mediaId: string | null;
  updatedAt?: string | null;
  fileType?: string | null;
};

export interface ViewMediaModalProps {
  images: ViewMediaImage[];
  preselectedCurrentIndex: number;
  showFileName?: boolean;
  imageBeautificationButtons?: boolean;
  getImageSrc?: (image: ViewMediaImage) => string;
}

export const ViewMediaModal: React.FC<ViewMediaModalProps> = (props) => {
  const modalContainerRef = useClickOutside<HTMLDivElement>(closeModal, true);

  return (
    <ModalBase
      ref={modalContainerRef}
      className="flex max-h-full w-[90vw] max-w-[1200px] flex-col overflow-hidden !p-4"
    >
      <CircleX
        onClick={closeModal}
        className="m-2 ml-auto cursor-pointer max-md:mt-0 [&_*]:stroke-primary"
        width={35}
        height={35}
      />
      <div className="flex h-full items-center justify-center overflow-hidden">
        <ImageCarousel
          {...props}
          onCloseModal={closeModal}
          imageBeautificationButtons={props.imageBeautificationButtons ?? true}
          getImageSrc={props.getImageSrc}
        />
      </div>
    </ModalBase>
  );
};
